"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamMemberCard = void 0;
const react_1 = __importDefault(require("react"));
const classFunctions_1 = require("../../../utils/classFunctions");
require("./index.scss");
const className = 'team-member-card';
class TeamMemberCard extends react_1.default.PureComponent {
    render() {
        const { name, image, position, phone, email, modificators, phoneTitle, emailTitle } = this.props;
        const classNames = (0, classFunctions_1.getClassNames)(className, modificators);
        return (react_1.default.createElement("div", { className: classNames },
            react_1.default.createElement("div", { className: `${className}__container` },
                react_1.default.createElement("div", { className: `${className}__image` },
                    react_1.default.createElement("img", { src: image, alt: name })),
                react_1.default.createElement("div", { className: `${className}__body` },
                    react_1.default.createElement("div", { className: `${className}__content` },
                        react_1.default.createElement("h3", { className: `${className}__name` }, name),
                        react_1.default.createElement("div", { className: `${className}__position` }, position),
                        react_1.default.createElement("div", { className: `${className}__info` },
                            react_1.default.createElement("div", { className: `${className}__row` },
                                react_1.default.createElement("div", { className: `${className}__label` }, phoneTitle),
                                react_1.default.createElement("div", { className: `${className}__value` }, phone)),
                            email && (react_1.default.createElement("div", { className: `${className}__row` },
                                react_1.default.createElement("div", { className: `${className}__label` }, emailTitle),
                                react_1.default.createElement("div", { className: `${className}__value` },
                                    react_1.default.createElement("a", { href: `mailto:${email}`, className: `${className}__email` }, email))))))))));
    }
}
exports.TeamMemberCard = TeamMemberCard;
TeamMemberCard.defaultProps = {
    name: null,
    image: null,
    position: null,
    phone: null,
    email: null,
    phoneTitle: 'Phone',
    emailTitle: 'Email',
};
//# sourceMappingURL=index.js.map